module.exports = __webpack_public_path__ + "static/img/xyrmyy.f744a1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/xyrmyy.png
// module id = nvVj
// module chunks = 0